<template>
  <div class="ncrm-home-header">
    <div class="ncrm-home-header__left">
      <v-icon v-if="icon" class="ncrm-home-header__icon" size="16">{{ icon }}</v-icon>
      <h1 class="ncrm-home-header__title">{{ title }}</h1>
      <span v-if="subtitle" class="ncrm-home-header__subtitle">{{ subtitle }}</span>
    </div>
    <div v-if="$slots.default || pageTourKey" class="ncrm-home-header__right">
      <slot />
      <PageHelpButton v-if="pageTourKey" :tour-key="pageTourKey" />
    </div>
  </div>
</template>

<script>
import PageHelpButton from "@/components/tours/PageHelpButton.vue";
import { getContextTourKeyForRoute } from "@/Utile/tours/tourDefinitions.mjs";

export default {
  name: "NcrmHomePageHeader",
  components: {
    PageHelpButton,
  },
  props: {
    /**
     * Teal icon shown before the title (MDI icon name, e.g. "mdi-handshake-outline").
     */
    icon: {
      type: String,
      default: "",
    },
    /**
     * Page title — displayed as h1.
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * Optional subtitle shown inline after the title separator.
     */
    subtitle: {
      type: String,
      default: "",
    },
  },
  computed: {
    /**
     * The help button only appears on pages that actually have a guided tour,
     * so shared admin surfaces reusing this header stay unchanged.
     */
    pageTourKey() {
      return getContextTourKeyForRoute(this.$route?.path) || "";
    },
  },
};
</script>

<style scoped>
.ncrm-home-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 2px 0 10px;
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.07);
}

.ncrm-home-header__left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1 1 0;
}

.ncrm-home-header__icon {
  flex-shrink: 0;
  color: rgb(var(--v-theme-tertiary));
  opacity: 0.85;
}

.ncrm-home-header__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.3;
  color: var(--app-text-strong);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ncrm-home-header__subtitle {
  font-size: 0.82rem;
  color: var(--app-text-default);
  opacity: 0.6;
  white-space: nowrap;
  padding-left: 8px;
  border-left: 1px solid rgba(var(--v-theme-on-surface), 0.18);
  margin-left: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ncrm-home-header__right {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

@media (max-width: 960px) {
  .ncrm-home-header {
    align-items: flex-start;
  }

  .ncrm-home-header__right {
    width: 100%;
    justify-content: flex-end;
  }

  .ncrm-home-header__subtitle {
    display: none;
  }
}
</style>
